import { FC } from 'react';

import { Button, InputWithSearchIcon } from 'common/components';

import { ACTION_ITEMS } from 'common/config/action.config';

import './ConfigurationHeader.scss';

type ConfigurationHeaderProps = {
    headerTitle: string;
    buttonTitle: string;
    searchVal: string;
    disableButton?: boolean;
    isButtonVisible?: boolean;
    hideClearButton?: boolean;
    isAddNewDisabled?: boolean;
    permissionList?: any;
    searchPlaceholder?: string;
    onSearchChangeHandler: (e: any) => void;
    onAddNew: () => void;
};

const ConfigurationHeader: FC<ConfigurationHeaderProps> = ({
    headerTitle,
    buttonTitle,
    searchVal,
    disableButton,
    isButtonVisible,
    hideClearButton,
    isAddNewDisabled,
    searchPlaceholder,
    onSearchChangeHandler,
    onAddNew
}: ConfigurationHeaderProps) => {
    return (
        <div className={`data-editor-header-container`}>
            <div className={`data-editor-header header-default`}>{headerTitle}</div>
            <div className="header-right">
                <InputWithSearchIcon
                    placeholder={
                        searchPlaceholder != undefined
                            ? searchPlaceholder
                            : ACTION_ITEMS.SEARCH_BUTTON
                    }
                    value={searchVal}
                    formClassName="search-input-wrapper"
                    className="search-input"
                    hideClearButton={hideClearButton}
                    onChange={onSearchChangeHandler}></InputWithSearchIcon>
                <Button
                    variant="primary"
                    className="data-editor-header-button"
                    disabled={isAddNewDisabled || disableButton}
                    onClick={onAddNew}
                    style={{ display: isButtonVisible ? 'block' : 'none' }}>
                    {buttonTitle}
                </Button>
            </div>
        </div>
    );
};

export default ConfigurationHeader;
